import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import { BREAKPOINT, WIDTH } from "../../../../constants/breakpoints";

//import general components
import BaseTabs from "../../../common/base-tabs/base-tabs";

//import images and icons
import Icon from "../../../common/base-icon/icon";

function OrdersCategory({ value, setValue, loading }) {
    //general variables
    const { t } = useTranslation();

    //handle changing the tabs at the top of the modal on mobile
    const [activeTab, setActiveTab] = useState({ flight: true, intFlight: false, hotel: false, intHotel: false, bus: false });
    const handleTabChange = type => {
        setActiveTab({ [type]: true });
        setValue(categoryList.find(item => item.type === type).id);
    };

    //category list
    const categoryList = [
        {
            id: 1,
            type: "flight",
            title: t("domesticFlight"),
            activeTab: activeTab?.flight,
            activeIcon: "AirplanActiveIcon",
            inactive: "AirplanInactiveIcon",
        },
        {
            id: 2,
            type: "intFlight",
            title: t("internationalFlight"),
            activeTab: activeTab?.intFlight,
            activeIcon: "IntlAirplanActiveIcon",
            inactive: "IntlAirplanInactiveIcon",
        },
        {
            id: 3,
            type: "hotel",
            title: t("hotel"),
            activeTab: activeTab?.hotel,
            activeIcon: "HotelActiveIcon",
            inactive: "HotelInactiveIcon",
        },
        {
            id: 4,
            type: "intHotel",
            title: t("internationalHotel"),
            activeTab: activeTab?.intHotel,
            activeIcon: "IntlHotelActiveIcon",
            inactive: "IntlHotelInactiveIcon",
        },
        {
            id: 5,
            type: "bus",
            title: t("bus"),
            activeTab: activeTab?.bus,
            activeIcon: "IntlHotelActiveIcon",
            inactive: "IntlHotelInactiveIcon",
        },
    ];

    //filter category
    const categoryRef = useRef(null);

    const [valuePosition, setValuePosition] = useState(1);
    const filterCategory = (event, newValue) => {
        if (loading) return;

        let bounds = categoryRef.current.getBoundingClientRect();
        let x = bounds.right - event.clientX;
        const percent = Math.round((x * 100) / bounds.width);
        const valueP = Math.ceil(5 * (percent / 100));
        setValuePosition(valueP);
        setValue(newValue);
    };

    return (
        <>
            {WIDTH > BREAKPOINT ? (
                <Grid className="orders__categories" container item xs={12} justifyContent="center" alignItems="center" ref={categoryRef}>
                    <span
                        className="orders__category-active"
                        style={{
                            right:
                                valuePosition === 1
                                    ? "5%"
                                    : valuePosition === 2
                                      ? "24%"
                                      : valuePosition === 3
                                        ? "43%"
                                        : valuePosition === 4
                                          ? "62%"
                                          : valuePosition === 5
                                            ? "80%"
                                            : "",
                            width: "170px",
                        }}
                    ></span>
                    {categoryList.map(categoryItem => {
                        return (
                            <Grid
                                className={`orders__category ${value === categoryItem.id ? "active" : ""}`}
                                key={categoryItem?.id}
                                container
                                item
                                xs={2.25}
                                justifyContent="center"
                            >
                                <Grid
                                    container
                                    item
                                    xs={12}
                                    columnGap={1}
                                    justifyContent="center"
                                    alignItems="center"
                                    onClick={event => filterCategory(event, categoryItem.id)}
                                >
                                    <Icon
                                        name={value === categoryItem.id ? categoryItem.activeIcon : categoryItem.inactive}
                                        style={{
                                            backgroundColor: value === categoryItem.id ? "var(--primary-color)" : "transparent",
                                            borderRadius: value === categoryItem.id ? "50%" : "0",
                                        }}
                                    />
                                    {categoryItem.title}
                                </Grid>
                            </Grid>
                        );
                    })}
                </Grid>
            ) : (
                <BaseTabs handleTabChange={handleTabChange} list={categoryList} style={{ top: "3rem" }} />
            )}
        </>
    );
}

export default OrdersCategory;
